var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dynamic-menu"},[_c('ul',_vm._l((_vm.menuItems),function(item){return _c('li',{key:item.text,class:{'active': item.active}},[_c('router-link',{staticClass:"text-TTDrugs-regular-16",attrs:{"to":item.link}},[_vm._v(_vm._s(item.text))])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }